import { useSettings } from "@app-composables/settings";

export function setupFontsFace() {
	const { bowlerBlobFontUrl } = useSettings();
	if (!bowlerBlobFontUrl || !bowlerBlobFontUrl.value) return;
	const styleLink = document.createElement("link");
	styleLink.rel = "stylesheet";
	styleLink.href = `${bowlerBlobFontUrl.value}/fonts.min.css`;
	document.head.appendChild(styleLink);
}
